import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, } from 'rxjs/operators';
import { cloneDeep, } from 'lodash';
import { Observable, Subject } from 'rxjs';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { CommonNotificationService } from '../../common-notification/common-notification.service';
import { AppSelectorService } from '../../app-selector/app-selector.service';
import { MediatorService } from 'src/app/data/repositories/apps/mediator/mediator.service';
import { ConfigManagerService } from '../config-manager.service';
@Injectable({
  providedIn: 'root'
})

export class FeatureListJsonService {
  mockJson = {
    home_page: {
      test_devices: 'enabled',
      interaction_maps: 'enabled',
      data_sources: 'enabled',
      user_management: 'enabled',
      apps: 'enabled',
      display_nudges: 'enabled',
      native_nudges: 'enabled',
      user_segments: 'enabled'
    },
    interaction_maps: {
      preview_interaction_map: {
        branch: 'disabled'
      },
      create_interaction_maps: {
        cta: 'enabled'
      },
      search_interaction_maps: 'enabled',
      results: {
        branch_results: 'enabled',
        show_ids_only: false,
        show_branch_ids: false
      },
      activate_interaction_map: 'enabled',
      add_split: {
        rollout: 'enabled',
        cta: 'enabled',
        user_split: 'enabled',
        ab_test: 'enabled'
      },
      delete_interaction_maps: 'enabled',
      add_nudge: {
        disabled_display_nudges: [
        ],
        display_nudge: 'enabled',
        cta: 'enabled',
        native_nudge: 'enabled',
        hidden_display_nudges: []
      },
      edit_interaction_map: 'enabled'
    },
    user_settings: {
      profile_settings: 'enabled',
      audit_logs_duration: -1
    },
    account_settings: {
      user_management: {
        user_add_cta: 'enabled',
        cta: 'enabled'
      },
      apps: {
        add_app_web: 'enabled',
        add_app_server: 'enabled',
        cta: 'enabled',
        add_app_android: 'enabled',
        add_app_ios: 'enabled',
        app_add_cta: 'enabled'
      },
      data_sources: {
        hanselpush: 'enabled',
        cta: 'enabled',
        dil: 'disabled'
      }
    },
    nudges: {
      native_nudges: 'enabled',
      display_nudges: 'enabled',
      cta: 'enabled'
    },
    sidebar: {
      test_devices: 'enabled',
      interaction_maps: 'enabled',
      user_segments: 'enabled',
      nudges: 'enabled',
    },
    hide_sandbox: false,
    event_data_upload: true,
    misc: {
      link_for_branch_active_snackbar: 'https://hansel.io'
    }
  };
  public platform_override = 'app_platform_override';
  public app_override = 'app_override';
  public planObject = {};
  public appLoaded = false;
  private appListReady = new Subject<any>();
  configJson = null;
  hiddenNudgeList: any = null;
  disabledNudgeList: any = null;
  hasNetworkFailed: Boolean = false;
  constructor(
    private http: HttpClient,
    private authenticationService: AuthenticationService,
    private appSelectorService: AppSelectorService,
    private commonNotificationService: CommonNotificationService,
    private mediatorService: MediatorService,
    private configManagerService: ConfigManagerService
  ) {
    this.fetchConfigValue();
  }

  public getAppListReady(): Observable<any> {
    return this.appListReady.asObservable();
  }

  mergeObject(baseObj, override) {
    baseObj = cloneDeep(baseObj);
    this.mergeObjectHelper(baseObj, override);
    return baseObj;
  }

  convertArrayToObject(values) {
    let obj = {};
    values.forEach(val => obj[val] = val);
    return obj;
  }

  segregateArray(sourceObj, mainObj) {
    for (const key in sourceObj) {
      if (this.isObjectArray(sourceObj[key])) {
        mainObj[key] = this.convertArrayToObject(sourceObj[key]);
      } else if (this.isPiousObject(sourceObj[key])) {
        this.segregateArray(sourceObj[key], mainObj);
      }
    }
  }

  mergeObjectHelper(sourceObj, override) {
    for (const key in override) {
      if (sourceObj[key] && this.isPiousObject(override[key])) {
        if (this.isPiousObject(sourceObj[key])) {
          this.mergeObjectHelper(sourceObj[key], override[key]);
        }
      } else {
        sourceObj[key] = override[key];
      }
    }
  }

  isObjectArray(obj) {
    return typeof (obj) === 'object' && Array.isArray(obj);
  }
  isPiousObject(obj) {
    return typeof (obj) === 'object' && !Array.isArray(obj);
  }
  // isObject(obj) {
  //   return obj === Object(obj) && Object.prototype.toString.call(obj) === "[object Object]";
  // }

  isAnyObject(obj) {
    return typeof obj === 'object' && obj !== 'null';
  }

  private overrideConfig(platform_name, configJson, platformOverride) {
    this.planObject[platform_name] = this.mergeObject(configJson, platformOverride);
  }

  private getConfigForApp(key) {
    const appObj = this.appSelectorService.getAppObj(key);
    // tslint:disable-next-line: max-line-length
    if (appObj && Object.keys(appObj).length && appObj.os && this.planObject[appObj['os']] && Object.keys(this.planObject[appObj['os']]).length) {
      return cloneDeep(this.planObject[appObj['os']]);
    } else {
      return cloneDeep(this.planObject['default']);
    }
  }

  private createMultipleConfigs(configJson) {
    let app_platform_config, app_config;
    if (configJson[this.platform_override]) {
      app_platform_config = configJson[this.platform_override];
      delete configJson[this.platform_override];
    }
    if (configJson[this.app_override]) {
      app_config = configJson[this.app_override];
      delete configJson[this.app_override];
    }
    this.planObject['default'] = cloneDeep(configJson);
    if (app_platform_config && Object.keys(app_platform_config).length) {
      const keys = Object.keys(app_platform_config);
      keys.forEach(key => this.overrideConfig(key, cloneDeep(configJson), app_platform_config[key]));
    }
    if (app_config && Object.keys(app_config).length) {
      const keys = Object.keys(app_config);
      keys.forEach(key => this.overrideConfig(key, this.getConfigForApp(key), app_config[key]));
    }
  }

  fetchDashboardConfig() {
    return new Promise((resolve, reject) => {
      this.getDashboardConfig().subscribe((res: any) => {
        if (
          res &&
          res.is_error === false &&
          res.api_response &&
          res.api_response.dashboard_configs
        ) {
          // this.configJson = this.mockJson;
          this.configJson = res.api_response.dashboard_configs;
          resolve();
          return;
        }
        reject();
      });
    });
  }

  waitForAppLoad() {
    return new Promise(resolve => {
      this.appSelectorService.loadApps(undefined, () => {
        this.appLoaded = true;
        resolve();
      });
      // this.appSelectorService.getAppsLoaded().subscribe(() => {

      // });
    });
  }

  fetchConfigValue() {
    if (this.configJson && this.planObject && Object.keys(this.planObject).length && this.appLoaded) {
      this.appListReady.next(true);
      this.mediatorService.raiseConfigReadyEvent(this.planObject);
      return;
    }
    this.fetchDashboardConfig()
      .then(() => {
        this.mediatorService.raiseConfigReadyEvent(this.configJson);
        return this.waitForAppLoad();
      })
      .then(() => {
        this.createMultipleConfigs(cloneDeep(this.configJson));
        const keys = Object.keys(this.planObject);
        keys.forEach(key => {
          this.segregateArray(cloneDeep(this.planObject[key]), this.planObject[key]);
        });
        this.appListReady.next(true);
        this.configManagerService.setPlanObject(this.planObject);
      })
      .catch(error => {
        this.commonNotificationService.showSnackBar(
          'Sorry, we are experiencing technical difficulties, Please try again later.',
          'error'
        );
        this.authenticationService.logout();
        this.appListReady.next(false);
      });
  }

  getDashboardConfig() {
    return this.http.get<any>('/dashboard/dashboardconfig').pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }

  checkStringValueForObjectKeys(len, stringSplit, clonedObject, comparetorValue, cb = null) {
    for (let i = 0; i < len - 1; i++) {
      // array also have hasOwnProperty method avaiable in the prototype, but in case of an array it always return false
      // so below check should work just fine for array's also
      if (clonedObject.hasOwnProperty([stringSplit[i]])) {
        if (this.isAnyObject(clonedObject[stringSplit[i]])) { // if value is any object
          clonedObject = clonedObject[stringSplit[i]];
        } else { // the value is primitive
          cb && cb(clonedObject[stringSplit[i]] === comparetorValue);
          return;
        }
      } else {
        cb && cb(false);
        return;
      }
    }
    if (this.isAnyObject(clonedObject[stringSplit[len - 1]])) { // if last item is an object
      cb && cb(false);
      return;
    } else {
      cb && cb(clonedObject[stringSplit[len - 1]] === comparetorValue);
      return;
    }
  }

  /**
   * this is to check for individual app for homepage and disable/enable links.
   * @param stringToCheck
   * @param comparetorValue
   * @param appData , it is an object contains: id, os
   * @param cb
   */
  shouldAppBeEnabled(stringToCheck, comparetorValue, appData, cb = null) {
    if (!stringToCheck) {
      cb && cb(false);
      return;
    }

    const stringSplit = stringToCheck.split('.');
    const len = stringSplit.length;

    if (!len) {
      cb && cb(false);
      return;
    }
    if (!Object.keys(this.planObject).length || !this.appLoaded) {
      this.getAppListReady().subscribe(value => {
        const configJson = this.returnTheConfigForApp(appData);
        const clonedObject = cloneDeep(configJson);
        this.checkStringValueForObjectKeys(len, stringSplit, clonedObject, comparetorValue, cb);
      });
    } else {
      const configJson = this.returnTheConfigForApp(appData);
      const clonedObject = cloneDeep(configJson);
      this.checkStringValueForObjectKeys(len, stringSplit, clonedObject, comparetorValue, cb);
    }
  }

  shouldEnableTheFeature(stringToCheck, comparetorValue, cb = null) {
    if (!stringToCheck) {
      cb && cb(false);
      return;
    }

    const stringSplit = stringToCheck.split('.');
    const len = stringSplit.length;

    if (!len) {
      cb && cb(false);
      return;
    }
    if (!Object.keys(this.planObject).length || !this.appLoaded) {
      this.getAppListReady().subscribe(value => {
        const configJson = this.returnTheConfig();
        let clonedObject = cloneDeep(configJson);
        this.checkStringValueForObjectKeys(len, stringSplit, clonedObject, comparetorValue, cb);
      })
    } else {
      const configJson = this.returnTheConfig();
      let clonedObject = cloneDeep(configJson);
      this.checkStringValueForObjectKeys(len, stringSplit, clonedObject, comparetorValue, cb);
    }
  }

  /**
   * this method is specific to homepage card, where we need to check for all the apps individually. this method helps us find the config related to particular app.
   */
  returnTheConfigForApp(appData) {
    if (appData && this.planObject[appData.id]) {
      return this.planObject[appData.id];
    } else if (appData && this.planObject[appData.os]) {
      return this.planObject[appData.os];
    } else {
      return this.planObject['default'];
    }
  }

  returnTheConfig() {
    const appObj = this.appSelectorService.getSelectedApp();
    if (appObj && this.planObject[appObj.id]) {
      return this.planObject[appObj.id];
    } else if (appObj && this.planObject[appObj.os]) {
      return this.planObject[appObj.os];
    } else {
      return this.planObject['default'];
    }
  }

  isPropertyPresentInList(listName, property, cb) {
    if (!Object.keys(this.planObject).length) {
      this.getAppListReady().subscribe(value => {
        const configJson: any = this.returnTheConfig();
        const flag = configJson[listName] && configJson[listName].hasOwnProperty(property);
        cb && cb(flag);
      });
    } else {
      const configJson: any = this.returnTheConfig();
      const flag = configJson[listName] && configJson[listName].hasOwnProperty(property);
      cb && cb(flag);
    }
  }

  returnTheLinkFor(string, cb = null) {
    if (!string) {
      cb && cb(false);
      return;
    }

    const stringSplit = string.split('.');
    const len = stringSplit.length;

    if (!len) {
      cb && cb(false);
      return;
    }
    if (!Object.keys(this.planObject).length || !this.appLoaded) {
      this.getAppListReady().subscribe(value => {
        const configJson = this.returnTheConfig();
        let clonedObject = cloneDeep(configJson);
        this.returnLink(len, stringSplit, clonedObject, cb);
      });
    } else {
      const configJson = this.returnTheConfig();
      const clonedObject = cloneDeep(configJson);
      this.returnLink(len, stringSplit, clonedObject, cb);
    }
  }

  returnLink(len, stringSplit, clonedObject, cb = null) {
    for (let i = 0; i < len - 1; i++) {
      // array also have hasOwnProperty method avaiable in the prototype, but in case of an array it always return false
      // so below check should work just fine for array's also
      if (clonedObject.hasOwnProperty([stringSplit[i]])) {
        if (this.isAnyObject(clonedObject[stringSplit[i]])) { // if value is any object
          clonedObject = clonedObject[stringSplit[i]];
        } else { // the value is primitive
          cb && cb(clonedObject[stringSplit[i]]);
          return;
        }
      } else {
        cb && cb(false);
        return;
      }
    }
    if (this.isAnyObject(clonedObject[stringSplit[len - 1]])) { // if last item is an object
      cb && cb(false);
      return;
    } else {
      cb && cb(clonedObject[stringSplit[len - 1]]);
      return;
    }
  }
}
